import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, CssBaseline, Box, Typography } from '@mui/material';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import theme from './theme';
import './global.css';
import NavBar from './components/NavBar';
// import About from './About';

import About from './about/About';
import NPCSelection from './NPCSelection';
import DetailNPC from './DetailNPC';
import DetailNPC_daily from './DetailNPC daily';
import NPCOverlay from './components/NPCOverlay';
import UserReadings from './components/UserReadings';
import Profile from './components/Profile'; // 用户资料页面
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import { getCurrentUser, initializeUser } from './services/userReadingService';
import { notifyAuthStateChange } from './components/UserReadings';

function AppContent() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState('about');
  const [activeNavLink, setActiveNavLink] = useState('character');
  const [selectedNPC, setSelectedNPC] = useState(null);
  const [cardViewProps, setCardViewProps] = useState(null);
  const [completeReading, setCompleteReading] = useState(null);
  const [isNPCOverlayOpen, setIsNPCOverlayOpen] = useState(false);

  const handleReadingComplete = (reading) => {
    setCompleteReading(reading);
  };

  const handleCardDraw = (props) => {
    setCardViewProps(props);
    setCurrentPage('reading');
    setActiveNavLink('reading');
    // navigate('/reading');
  };

  const handleInitialStressChange = (level) => {
    console.log(`Initial confidence level set to: ${level}/10`);
    // Store this value if needed or pass it to other components
  };

  const handleNavigation = (page) => {
    setCurrentPage(page);
    // if (page === 'reading' && !cardViewProps) {
    //   // If trying to access reading page without a reading, redirect to question
    //   setCurrentPage('question');
    //   setActiveNavLink('question');
    //   navigate('/question');
    //   return;
    // }
    navigate(`/${page}`);
  };

  const handleNPCSelect = (npcData) => {
    setSelectedNPC(npcData);
    setIsNPCOverlayOpen(false); // Close overlay on selection
    setCurrentPage('question');
    setActiveNavLink('question');
    // navigate('/question');
  };

  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}>
      <NavBar 
        currentPage={currentPage}
        activeNavLink={activeNavLink}
        onNavigate={handleNavigation}
        onNavLinkChange={setActiveNavLink}
        onCharacterHover={(isHovering) => setIsNPCOverlayOpen(isHovering)}
      />
      <Box sx={{ 
        flexGrow: 1,
        pt: '64px', // Same as navbar height
        bgcolor: 'background.default',
      }}>
        <Routes>
          <Route path="/" element={<About onNavigate={handleNavigation}/>} />
          <Route path="/about" element={<About onNavigate={handleNavigation}/>} />
          <Route 
            path="/character" 
            element={
              <NPCSelection onSelectNPC={handleNPCSelect} />
            } 
          />
          <Route 
            path="/detail" 
            element={<DetailNPC onSelectNPC={handleNPCSelect} onCardDraw={handleCardDraw}/>} 
          />
          {/* <Route 
            path="/question" 
            element={
              <TarotInterface 
                onCardDraw={handleCardDraw}
                selectedNPC={selectedNPC}
                onInitialChange={handleInitialStressChange}
              />
            } 
          /> */}
          <Route 
            path="/readings" 
            element={
              <UserReadings />
            }
          />
          <Route 
            path="/profile" 
            element={<Profile />} 
          />
          <Route
            path="/fortune"
            element={<DetailNPC_daily onSelectNPC={handleNPCSelect} onCardDraw={handleCardDraw} />}
          />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy />}
          />
          <Route
            path="/terms-of-service"
            element={<TermsOfService />}
          />
          <Route
            path="*"
            element={
              <Box sx={{ p: 4 }}>
                <Typography variant="h4">Page not found</Typography>
              </Box>
            }
          />
        </Routes>
        
        <NPCOverlay 
          isOpen={isNPCOverlayOpen}
          onClose={() => setIsNPCOverlayOpen(false)}
          onSelectNPC={handleNPCSelect}
          onMouseLeave={() => setIsNPCOverlayOpen(false)}
        />
      </Box>
    </Box>
  );
}

function App() {
  useEffect(() => {
    // 应用启动时恢复认证状态
    const initializeAuth = async () => {
      const storedUser = localStorage.getItem('aitarot_user');
      if (storedUser) {
        try {
          const userData = JSON.parse(storedUser);
          console.log('应用启动时发现用户数据，恢复认证状态:', userData);
          
          // 尝试同步到服务器（失败也没关系）
          try {
            await initializeUser(userData);
          } catch (e) {
            console.warn('服务器同步失败，使用本地模式:', e);
          }
          
          // 通知所有组件认证状态已恢复
          notifyAuthStateChange();
        } catch (e) {
          console.error('恢复认证状态失败:', e);
          localStorage.removeItem('aitarot_user'); // 清除损坏的数据
        }
      }
    };
    
    initializeAuth();
  }, []);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppContent />
      </ThemeProvider>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
